import { SEARCH_ARCHIVE } from 'config/types/path';
import { createSelector } from 'reselect';
import { compile } from 'path-to-regexp';
import get from 'lodash/fp/get';
import range from 'lodash/fp/range';
import getActivePagination from './getActivePagination';
import getPathMap from './getPathMap';
import getMatch from './getMatch';
import { getRouteKey } from './';

export const getSearchPath = createSelector(
  [
    getPathMap,
    getMatch,
  ],
  (pathMap, { params }) => {
    const searchToPath = compile(pathMap[SEARCH_ARCHIVE]);
    const languageEdition = 'en-US' === params.language ? 'en' : params.language;
    return searchToPath({
      ...params,
      language: languageEdition,
      page: 1,
    });
  },
);

export const getSearchParams = createSelector(
  [getMatch],
  (match) => ({ s: '', ...match.query }),
);

export const getSearchResultsShowing = createSelector(
  [
    get('archive'),
    getRouteKey,
    getActivePagination,
  ],
  (archiveState, routeKey, { currentPage, perPage }) => {
    const pages = get([routeKey, 'pages'], archiveState);
    const pageNumbers = Object.keys(pages);

    // Get span of results displaying based on count of items in cached pages (falling back to perPage value)
    if (pageNumbers.length && pages[currentPage]) {
      const firstItemPosition = range(1, currentPage + 1).reduce(
        (acc, pageNumber) => {
          const pageItems = pages[pageNumber];
          let count = acc;

          if (!pageItems) {
            count += perPage;
          } else if (pageNumber < currentPage) {
            count += pageItems.length;
          } else if (currentPage === pageNumber) {
            count += 1;
          }

          return count;
        }, 0);

      return [
        firstItemPosition,
        firstItemPosition + (pages[currentPage].length - 1),
      ];
    }

    return [];
  },
);
